<template>
    <div id="pt091" class="pt091" v-cloak>
        <div class="itemTitle">
            <h2>{{$t('pt090.labels.title')}}</h2>
        </div>
        <div class="infoDetail" >
            <template v-if="osYmdFrom != null">
                <div>
                    <p class="osYmdFrom">
                        {{osYmdFrom}}
                    </p>
                </div>
            </template>
            <template v-if="osTitle != null">
                <div>
                    <p>
                        <img src="../img/icons/news_icon.gif">
                        <b class="ml-1">{{osTitle}}</b>
                    </p>
                </div>
            </template>
                
            <template v-if="osNaiyou != null">
                <div>
                    <div v-html="osNaiyou"></div>
                </div>
            </template>

            <template v-if="strErrMsg">
                <p>
                    {{strErrMsg}}
                </p>
            </template>
        </div>
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import SiteConstants from 'assets/const/SiteConstants.json';
import common from "assets/js/common";
import axios from "assets/js/request";

export default {
    /* 
    * Name of component
    */
    name: "PT091InformationDetailParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Declare components
    */
    components: {
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            pt091Request:{},
            pt091Init:{},
            storeTitleFlg: 0,
            infoPageOption: 0,
            SiteConstants: SiteConstants,
            osTitle:null,
            osNaiyou:null,
            strErrMsg:null,
            storeTitleFlg: 0,
            ecOpenFlg: 0,
            headerTitle: null
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        if (_this.ptInitData){
            _this.pt091Init = _this.ptInitData;
        }else{
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.PT090 + _this.$UrlConstants.DO_INIT, _this.pt091Request).then(function(response) {
                _this.pt091Init = response.data;
            })
            .catch(function(error) {
                common.errorAPI(error);
            });
        }
        _this.osTitle = _this.pt091Init.osTitle;
        _this.osNaiyou = _this.pt091Init.osNaiyou;
        _this.strErrMsg = _this.pt091Init.strErrMsg;
        _this.storeTitleFlg = _this.pt091Init.storeTitleFlg;
        _this.ecOpenFlg = _this.pt091Init.ecOpenFlg;
        _this.osYmdFrom = _this.pt091Init.osYmdFrom;
        _this.headerTitle = _this.$i18n.t('pt090.labels.title');
    },
    /* 
    * Methods
    */
    methods: {
    },
    /*
    * クエリーパラメータで遷移してきた場合、クエリーの値をpt091Detailにセットする
    */
    created: function(){
        var _this =this;
        var queryData = _this.$route.query;
        if(Object.keys(queryData).length > 0){
            _this.pt091Detail = Object.assign({}, _this.pt091Detail, queryData);
        }
    },
}
</script>
